<div class="timeline-board">
  <div class="timeline-scroll">
    <div class="timeline-sheet" [style.width.px]="headWidth + trackWidth()">
      <div class="timeline-header">
        <div class="timeline-corner" [style.width.px]="headWidth">{{ rowHeader() }}</div>
        <div class="timeline-scale" [style.width.px]="trackWidth()">
          <div class="timeline-weeks">
            @for (week of weeks(); track week.key) {
              <div class="timeline-week" [style.width.px]="week.days * dayWidth()">
                <span>{{ week.label }}</span>
              </div>
            }
          </div>
          <div class="timeline-days">
            @for (column of columns(); track column.index) {
              <div
                class="timeline-day-head"
                [class.is-weekend]="column.isWeekend"
                [class.is-today]="column.isToday"
                [class.is-week-start]="column.isMonday"
                [style.width.px]="dayWidth()"
              >
                <span class="timeline-day-name">{{ column.dayName }}</span>
                <span class="timeline-day-number">{{ column.dayNumber }}</span>
              </div>
            }
          </div>
        </div>
      </div>

      @for (row of rows(); track row.id) {
        <div class="timeline-row">
          <button type="button" class="timeline-row-head" [style.width.px]="headWidth" (click)="rowClicked.emit(row)">
            <span class="timeline-row-title">{{ row.title }}</span>
            @if (row.subtitle) {
              <span class="timeline-row-subtitle">{{ row.subtitle }}</span>
            }
          </button>

          <div
            #track
            class="timeline-track"
            [class.is-drop-row]="dropTarget()?.rowId === row.id"
            [style.width.px]="trackWidth()"
            (dragover)="onDragOver($event, row, track)"
            (dragleave)="onDragLeave($event, track)"
            (drop)="onDrop($event, row, track)"
          >
            @for (column of columns(); track column.index) {
              <div
                class="timeline-cell"
                [class.is-week-start]="column.isMonday"
                [class.is-off]="row.days && row.days[column.index] && row.days[column.index].available <= 0"
                [style.left.px]="column.index * dayWidth()"
                [style.width.px]="dayWidth()"
                [attr.title]="row.days && row.days[column.index] ? dayTitle(row.days[column.index]) : null"
              >
                @if (row.days && row.days[column.index] && row.days[column.index].available > 0) {
                  <div class="timeline-cell-load">
                    <div
                      class="timeline-cell-load-fill"
                      [class.is-full]="loadPercent(row.days[column.index]) >= 99"
                      [style.width.%]="loadPercent(row.days[column.index])"
                    ></div>
                  </div>
                }
              </div>
            }

            @for (bar of visibleBars(row); track bar.id) {
              <div
                class="timeline-bar"
                [class]="toneClass(bar)"
                [class.is-locked]="bar.locked"
                [class.is-dragging]="drag.current()?.itemId === bar.id"
                [class.is-narrow]="width(bar) < 70"
                [style.left.px]="left(bar.start)"
                [style.width.px]="width(bar)"
                [attr.draggable]="!bar.locked"
                (dragstart)="onDragStart($event, bar, row)"
                (dragend)="onDragEnd()"
                (click)="barClicked.emit(bar)"
                (mousemove)="showHover($event, bar)"
                (mouseleave)="hideHover()"
              >
                @if (bar.locked) {
                  <span class="timeline-bar-live" aria-hidden="true"></span>
                }
                <span class="timeline-bar-text">
                  <span class="timeline-bar-label">{{ bar.label }}</span>
                  @if (bar.sublabel) {
                    <span class="timeline-bar-sublabel">{{ bar.sublabel }}</span>
                  }
                </span>
                @if (bar.pinned) {
                  <i class="fa fa-thumbtack timeline-bar-pin" aria-hidden="true"></i>
                }
                @if (bar.flag) {
                  <i class="fa fa-exclamation-triangle timeline-bar-flag" aria-hidden="true"></i>
                }
                @if (bar.badge) {
                  <span class="timeline-bar-badge">{{ bar.badge }}</span>
                }
              </div>
            }

            @if (dropTarget(); as target) {
              @if (target.rowId === row.id) {
                <div
                  class="timeline-drop-marker"
                  [class.is-start-at]="target.startAt !== null"
                  [style.left.px]="left(target.position)"
                ></div>
              }
            }

            @if (nowPosition() !== null && nowPosition() >= 0 && nowPosition() <= days()) {
              <div class="timeline-now" [style.left.px]="left(nowPosition())"></div>
            }
          </div>
        </div>
      } @empty {
        <div class="timeline-empty">{{ emptyText() }}</div>
      }
    </div>
  </div>

  @if (hover(); as current) {
    <div
      class="timeline-tooltip"
      [class.is-flip-x]="current.flipX"
      [class.is-flip-y]="current.flipY"
      [style.left.px]="current.x"
      [style.top.px]="current.y"
    >
      <div class="timeline-tooltip-title">{{ current.bar.label }}</div>
      @if (current.bar.sublabel) {
        <div class="timeline-tooltip-subtitle">{{ current.bar.sublabel }}</div>
      }
      @for (detail of current.bar.details ?? []; track detail.label) {
        <div class="timeline-tooltip-line">
          <span class="timeline-tooltip-label">{{ detail.label }}</span>
          <span class="timeline-tooltip-value">{{ detail.value }}</span>
        </div>
      }
      @if (current.bar.flag) {
        <div class="timeline-tooltip-flag">
          <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ current.bar.flag }}
        </div>
      }
      @if (current.bar.locked && current.bar.lockedReason) {
        <div class="timeline-tooltip-note">
          <i class="fa fa-lock" aria-hidden="true"></i> {{ current.bar.lockedReason }}
        </div>
      }
    </div>
  }
</div>
